<template>
    <svg version="1.1" width="36" height="36" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" xml:space="preserve">

        <g>
	<g id="Date_of_manufacture">
		<g id="Group_1" transform="translate(7420.459 -627.586)">
			<path :class="secondaryColor" d="M-7396.9,632.7v13.5l-3.2-5.2l-2.9,4.7l-2.9-4.7l-2.9,4.7l-2.9-4.7l-4.7,7.6v10h28v-25.9H-7396.9z
				 M-7390,657h-25v-8l3.2-5.2l2.9,4.7l2.9-4.7l2.9,4.7l2.9-4.7l2.9,4.7h1.8v-14.3h5.4L-7390,657z"/>
		</g>
	</g>
</g>
</svg>


</template>

<script>
export default {
    name: "dateOfManufactureIcon",
    computed :{
        secondaryColor() {
            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/dateOfManufactureIcon.vue